export var code = function code(text) {
  return "{{".concat(text, "}}");
};